// removed by extract-text-webpack-plugin
module.exports = {"content":"ConnectionList__content___3_ljt","border":"ConnectionList__border___1vdQ-"};